import axios from 'axios';
import store from '../store'
import router from '../router';


const httpClient = axios.create({
    baseURL: 'https://oliviaprirodnisapuni.duckdns.org',
    // baseURL: 'http://localhost:9001',
    timeout: 4000
});

const requestInterceptor = config => {
    const jwt = store.getters.getJWT
    if (jwt)
        config.headers.Authorization = `Bearer ${jwt}`
    return config
}

const requestErrorInterceptor = error => {
    return Promise.reject(error)
}

httpClient.interceptors.request.use(requestInterceptor, requestErrorInterceptor)

const responseInterceptor = response => response

async function responseErrorInterceptor(error) {
    const originalRequest = error.config

    if ((error.response.status === 401 || error.response.status === 403) && originalRequest.url === '/refreshJWT') {
        store.commit('clearAuthenticationState')
        // noinspection JSCheckFunctionSignatures
        router.go(router.currentRoute)
    } else if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
        originalRequest._retry = true
        await store.dispatch('refreshToken')
        return httpClient(originalRequest)
    }

    return Promise.reject(error)
}

httpClient.interceptors.response.use(responseInterceptor, responseErrorInterceptor)

export default httpClient;
